import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthenticationService } from '@app/shared/services';

import { MensagemService } from '@app/shared/services/mensagem.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  urlsToNotUse: Array<string>;

  constructor(private authenticationService: AuthenticationService, private mensagemService: MensagemService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((erro) => {
        setTimeout(() => {
          if (!navigator.onLine) {
            this.mensagemService.avisoMensagemAlerta('', 'Sem conexão com a internet');
          } else if (erro.status === 422 || erro.status === 400 || erro.status === 404) {
            if (erro.error != null && erro.error instanceof Array) {
              let mensagem = '';

              for (const e of erro.error) {
                mensagem += e + '\n';
              }
              this.mensagemService.avisoMensagemAlerta('', mensagem);
            } else {
              this.mensagemService.avisoMensagemAlerta('', erro.error.message);
            }
          } else if (this.isAutenticar(req.url) && erro.status === 400) {
            this.mensagemService.avisoMensagemAlerta('Não localizamos suas informações. Por favor, revise as informações e tente novamente ou entre em contato com o instituto.', 'Atenção!');
          } else if (erro.status === 403 || erro.status === 401) {
            this.authenticationService.logout();
            this.mensagemService.avisoMensagemAlerta('Não localizamos suas informações. Por favor, revise as informações e tente novamente ou entre em contato com o instituto.', 'Acesso Negado!');
          } else if (erro.status === 500) {
            this.mensagemService.avisoMensagemError('', 'Ocorreu um erro no servidor');
          } else if (erro.status === 503) {
            this.mensagemService.avisoMensagemError('', 'Servidor fora do ar');
          } else if (typeof erro === 'string' && erro == 'Unknown Error') {
            this.mensagemService.avisoMensagemAlerta('Tente novamente ou contate o suporte', 'Ocorreu um erro na operação');
          } else if (typeof erro === 'string') {
            this.mensagemService.avisoMensagemAlerta(erro, 'Ocorreu um erro na operação');
          } else {
            this.mensagemService.avisoMensagemError('', 'Ocorreu um erro no servidor');
          }
        }, 200);

        return throwError(erro);
      })
    );
  }

  private isAutenticar(requestUrl: string): boolean {
    let urlApi: string[] = ['autenticar', 'authenticate']

    for (const url of urlApi) {
      if (requestUrl.indexOf(url) != -1) {
        return true
      }
    }

    return false
  }

}
